import { AppNavMenu, AppRoute } from 'src/pages';
import { AppointmentsList } from './appointment/list';
import { AppointmentSlotList } from './appointmentSlots';
import { CallDetails, CallList } from './calls';
import { PhoneOutlined, CalendarOutlined } from '@ant-design/icons';

export const frontdeskRoutes: AppRoute[] = [
  {
    path: '/frontdesk/appointments',
    element: <AppointmentsList />,
  },
  {
    path: '/frontdesk/appointment-slots',
    element: <AppointmentSlotList />,
  },
  {
    path: '/frontdesk/calls',
    element: <CallList />,
  },
  {
    path: '/frontdesk/calls/:callId',
    element: <CallDetails />,
  },
];

export const frontdeskNavMenus: AppNavMenu[] = [
  {
    path: '/frontdesk/calls',
    title: 'Frontdesk',
    icon: <PhoneOutlined />,
    submenu: [
      {
        path: '/frontdesk/appointments',
        title: 'Frontdesk Appointments',
        icon: <PhoneOutlined />,
      },
      {
        path: '/frontdesk/appointment-slots',
        title: 'Frontdesk Appointment Slots',
        icon: <CalendarOutlined />,
      },
    ],
  },
];
